import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {NavigationService} from "../../../shared/services/navigation.service";
import {Subscription} from "rxjs";
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
    selector: 'app-sidebar-top',
    templateUrl: './sidebar-top.component.html',
    standalone: true,
    imports: [SidenavComponent]
})
export class SidebarTopComponent implements OnInit, OnDestroy {
  private navService = inject(NavigationService);

  public menuItems: any[];
  private menuItemsSub: Subscription;

  ngOnInit() {
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      this.menuItems = menuItem.filter(item => item.type !== 'icon' && item.type !== 'separator');
    });
  }
  ngOnDestroy() {
    if( this.menuItemsSub ) {
      this.menuItemsSub.unsubscribe()
    }
  }

}
